import routerMap from '@/router/routerMap';
import { MEMBER_DETAIL, MY_PRIVATE_SEA_PATH } from '@/type/router';
import { MenuItem } from '../../type/menu';

/**
 * 菜单总列表（后续增加模块可直接加入）
 */
export const menuRouter: Array<MenuItem> = [
  {
    chname: '体验新模式',
    name: 'newMyClass',
    path: routerMap.newMyClass
  },
  {
    chname: '我的班级',
    name: 'myClass',
    path: `/myClass`
  },
  {
    chname: '招生服务',
    name: 'enrollment',
    path: '/enrollment',
    children: [
      {
        chname: '我的私海',
        name: 'mySea',
        path: MY_PRIVATE_SEA_PATH
      },
      {
        chname: '成单明细',
        name: 'orderDetail',
        path: `/enrollment/orderDetail`
      },
      {
        chname: '小红书成单明细',
        name: 'redBooklet',
        path: `/enrollment/redBooklet`
      },
      {
        chname: 'CC私海',
        name: 'ccSea',
        path: '/enrollment/ccSea'
      },
      {
        chname: '班主任私海',
        name: 'teacherPrivateSea',
        path: `/enrollment/teacherPrivateSea`
      },
      {
        chname: '我的私海（高）',
        name: 'highPrivateSea',
        path: `/enrollment/highPrivateSea`
      }
      // {
      //   chname: '外呼接线',
      //   name: 'predictiveOutboundCall',
      //   path: `/enrollment/predictiveOutboundCall`
      // },
      // {
      //   chname: '接线列表',
      //   name: 'wiringList',
      //   path: `/enrollment/wiringList`
      // }
    ]
  },
  {
    chname: '我的任务',
    name: 'myTask',
    path: '/myTask'
  },
  {
    chname: '常用工具',
    name: 'tools',
    path: `/commonTools`,
    children: [
      // {
      //   chname: '录屏工具',
      //   name: 'mediaRecorder',
      //   path: `/commonTools/videoRecord`
      // },
      {
        chname: '购课链接',
        name: 'buyCourseLink',
        path: `/commonTools/buyCourseLink`
      },
      {
        chname: '班级建课',
        name: 'class-add-course',
        path: `/commonTools/createCourse`
      },
      {
        chname: '班级管理',
        name: 'class-manage',
        path: `/commonTools/classManage`
      },
      {
        chname: '华佗平台',
        name: 'huatuo',
        path: `/commonTools/huatuoPlatform`
      },
      {
        chname: '企微回执',
        name: 'micro-receipt',
        path: `/commonTools/microReceipt`
      },
      {
        chname: '转化赠课',
        name: 'convert-give-lessons',
        path: `/commonTools/grantCourse`
      },
      {
        chname: '全量学员搜索',
        name: 'all-search',
        path: `/commonTools/searchStudent`
      },
      {
        chname: 'CPS海报',
        name: 'cps',
        path: '/commonTools/cpsList'
      },
      {
        chname: '短信发送记录',
        name: 'sms-record',
        path: '/commonTools/smsRecord'
      },
      // 回放情况
      {
        chname: '回放情况',
        name: 'playbackStatus',
        path: `/commonTools/playbackStatus`
      }
    ]
  },
  {
    chname: '管理工具',
    name: 'manageTool',
    path: '/manageTool',
    children: [
      {
        chname: '组员明细',
        name: 'teamMember',
        path: MEMBER_DETAIL
      },
      {
        chname: '私海分配名单管理',
        name: 'seaHandDeal',
        path: `/manageTool/seaHandDeal`
      },
      {
        chname: '私海配置',
        name: 'manualDistribution',
        path: `/manageTool/manualDistribution`
      },
      {
        chname: 'CC手动分配',
        name: 'ccManualDistribution',
        path: `/manageTool/ccManualDistribution`
      },
      {
        chname: '私海明细',
        name: 'privateSeaDetail',
        path: `/manageTool/privateSeaDetail`
      },
      {
        chname: '批改端备课权限',
        name: 'permissionlist',
        path: `/manageTool/permissionlist`
      },
      // highPrivateSeaLPManage
      {
        chname: '高中私海LP管理',
        name: 'highPrivateSeaLPManage',
        path: `/manageTool/highPrivateSeaLPManage`
      },
      {
        chname: '批改端甩班作业分配',
        name: 'changeclass',
        path: `/manageTool/changeclass`
      },
      {
        chname: '英语年级版本维护',
        name: 'gradeversionCollect',
        path: '/managetool/gradeversion/collect'
      },
      {
        chname: '学情问卷',
        name: 'academicQuestionnaire',
        path: `/manageTool/academicQuestionnaire`
      }
    ]
  },
  {
    chname: '数据看板',
    name: 'dataBoard',
    path: '/dataBoard',
    children: []
  }
];

export const moduleRouter = {
  '/myClass': ['student', 'lesson', 'classLog', 'allLesson', 'survey'],
  '/newMyClass': ['newStudent', 'newLesson', 'newClassLog', 'newAllLesson', 'survey']
};

/**
 * 菜单信息
 */
export interface MenuInfo {
  detail_column?: Array<object>;
  statistics_column?: Array<object>;
  single_tool?: Array<object>;
  batch_tool?: Array<object>;
  sop_ids?: string;
  sop_ids_long_class?: string;
  sop_ids_short_class?: string;
}

/**
 * 权限列表
 */
export interface AuthItem {
  url: string;
  type: number;
  plid: string;
  menu_name: string;
  lid: string;
  class_type: number;
  child_menu: AuthItem[];
  menu_info?: MenuInfo;
}

/**
 * 工具
 */
export interface Tool {
  lid?: string;
  name?: string;
  action?: string;
  template_ids?: string;
  id?: string;
  text?: string;
}
